class Card6Controller {
	constructor($scope) {
		this.name = 'card6'
		this.$scope = $scope
	}

	$onInit() {
		this.data.owner.avatarUrl = this.data.owner.avatarUrl || 'https://instagram.ftbs4-1.fna.fbcdn.net/vp/396a1ebe6ad2ac9d8d78d1f51f5c81fb/5BA70AE0/t51.2885-19/s150x150/32121571_934638350050642_1109616637851467776_n.jpg'
	}
}

Card6Controller.$inject = ['$scope']

export default Card6Controller



// WEBPACK FOOTER //
// ./client/app/components/home/book/step3/card6/card6.controller.js